export const RelationshipsToMinorEnum = {
  Father: 'FATHER',
  Mother: 'MOTHER',
  Other: 'OTHER',
} as const;

export const RelationshipsToMinorLabelsEnum = {
  [RelationshipsToMinorEnum.Father]: 'Father',
  [RelationshipsToMinorEnum.Mother]: 'Mother',
  [RelationshipsToMinorEnum.Other]: 'Other',
} as const;

export type RelationshipsToMinor =
  (typeof RelationshipsToMinorEnum)[keyof typeof RelationshipsToMinorEnum];
